import React from "react";
import NoDataMessage from "../NoDataMessage";
import AlertListItem from "../AlertListItem";
import ShowMorePager from "../ShowMorePager";
import AlertIdNotFoundMessage from "../AlertIdNotFoundMessage";

const AlertListBody = props => {
  if (props.pagedAlerts.length === 0) {
    return <NoDataMessage />;
  }

  if (props.showAlertIdNotFoundMessage) {
    return <AlertIdNotFoundMessage />;
  }

  return (
    <div>
      <div className="fable:space-y-4">
        {props.pagedAlerts.map(alert => (
          <div key={alert.alertId}>
            <AlertListItem alert={alert} redirectTo={props.redirectTo} />
          </div>
        ))}
      </div>
      {props.pagingEnabled && (
        <ShowMorePager
          isPaging={props.isPaging}
          onPageChange={props.onPageChange}
        />
      )}
    </div>
  );
};

export default AlertListBody;
